module.exports = __webpack_public_path__ + "static/media/2015.cd2587a6.png";